import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import { IntakeAnswers, IntakeSectionGroup } from '../../types/intakeSurvey';
import IntakeSurveyForm from './IntakeSurveyForm';
import { getIntakeIcon } from './intakeSectionIcons';

interface IntakeSurveySectionProps {
  group: IntakeSectionGroup;
  answers: IntakeAnswers;
  fieldErrors: Record<string, string>;
  onChange: (id: string, value: string | number | string[]) => void;
}

const IntakeSurveySection: React.FC<IntakeSurveySectionProps> = ({
  group,
  answers,
  fieldErrors,
  onChange,
}) => {
  const SectionIcon = getIntakeIcon(group.section.icon);

  return (
    <Box component="section" sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
        {SectionIcon && (
          <SectionIcon color="primary" aria-hidden />
        )}
        <Typography variant="h6" component="h2" sx={{ fontWeight: 700 }}>
          {group.section.title}
        </Typography>
      </Box>
      <Divider sx={{ mb: 3 }} />
      {group.questions.map((question) => (
        <IntakeSurveyForm
          key={question.id}
          question={question}
          answers={answers}
          fieldError={fieldErrors[question.id]}
          onChange={onChange}
        />
      ))}
    </Box>
  );
};

export default IntakeSurveySection;
